export function useApolloLogin() {
  const { getToken } = useApollo();

  return getToken().then((res) => {
    if (res) return true;
    else return false;
  });
}
